import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import conectedLogo from '../assets/logo-conectedit.png';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login, error } = useAuthStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [localError, setLocalError] = useState('');
  const [tenants, setTenants] = useState<Array<{ id: string; name: string }>>([]);
  const [tenantId, setTenantId] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError('');
    setIsLoading(true);

    try {
      await login({ email, password, tenantId: tenantId || undefined });
      const loggedUser = useAuthStore.getState().user;
      navigate(loggedUser?.roles?.includes('EMPLOYEE') ? '/mi-portal' : '/dashboard');
    } catch (err: any) {
      const data = err.response?.data;
      if (data?.code === 'TENANT_SELECTION_REQUIRED' && Array.isArray(data.tenants)) {
        setTenants(data.tenants);
        setTenantId(data.tenants[0]?.id || '');
        setLocalError('');
      } else {
        setLocalError(err.code === 'ECONNABORTED' ? 'El servidor tardó demasiado en responder. Volvé a intentar.' : data?.message || 'No se pudo iniciar sesión. Intentá nuevamente.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container login-page">
      <div className="login-shell">
        <aside className="login-showcase">
          <div className="login-company-brand">
            <img className="login-company-wordmark" src={conectedLogo} alt="ConectedIT Software Factory" />
          </div>
          <div className="login-showcase-copy">
            <span className="login-kicker">Recibos Digitales</span>
            <h1>Tu documentación laboral, simple y segura.</h1>
            <p>Recibos, firmas y novedades importantes en un único espacio, disponible cuando lo necesites.</p>
            <div className="login-benefits">
              <div><span aria-hidden="true">✓</span><p><strong>Acceso protegido</strong><small>Información separada y segura por empresa.</small></p></div>
              <div><span aria-hidden="true">✓</span><p><strong>Todo en un solo lugar</strong><small>Consultá y firmá tus recibos desde cualquier dispositivo.</small></p></div>
              <div><span aria-hidden="true">✓</span><p><strong>Siempre al día</strong><small>Recibí avisos cuando haya novedades para vos.</small></p></div>
            </div>
          </div>
          <div className="login-showcase-footer">Tecnología desarrollada por ConectedIT</div>
        </aside>

        <main className="login-card">
        <div className="login-header">
          <div className="login-product-mark"><img src={conectedLogo} alt="ConectedIT Software Factory" /></div>
          <span className="login-mobile-brand">Recibos Digitales</span>
          <h2>Bienvenido</h2>
          <p>Ingresá con tus datos para continuar.</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {(localError || error) && (
            <div className="error-message">
              {localError || error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Correo electrónico</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setTenants([]);
                setTenantId('');
              }}
              required
              disabled={isLoading}
              placeholder="nombre@empresa.com"
            />
          </div>

          {tenants.length > 0 && (
            <div className="form-group">
              <label htmlFor="tenantId">Empresa</label>
              <select
                id="tenantId"
                value={tenantId}
                onChange={(e) => setTenantId(e.target.value)}
                required
                disabled={isLoading}
              >
                {tenants.map((tenant) => (
                  <option key={tenant.id} value={tenant.id}>{tenant.name}</option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="login-button"
          >
            {isLoading ? 'Ingresando…' : 'Ingresar a mi cuenta'}
          </button>
          <Link className="login-link" to="/recuperar-clave">¿Olvidaste tu contraseña?</Link>
        </form>

        <div className="login-trust"><span aria-hidden="true">●</span> Conexión segura y datos protegidos</div>
        </main>
      </div>
    </div>
  );
};

export default LoginPage;
